import { connect } from 'react-redux';
import MobileFilterDrawer from './MobileFilterDrawer';
import { setMobileFilterDrawerOpen } from '../store/supplierAuthorizationSlice';

const mapState = state => ({
  mobileFilterDrawerOpen: state.loadingManagement.supplierAuthorizations.mobileFilterDrawerOpen,
});

const mapDispatchToProps = {
  setMobileFilterDrawerOpen,
};

export default connect(mapState, mapDispatchToProps)(MobileFilterDrawer);
